// @flow

import routes from 'app/use-case/routes';

export default {
  routes,
};
